import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f1ae86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 d-flex justify-content-end mt-2 mt-sm-0 px-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-onlineshopping text-color-brand1",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/your-reservations",
      class: "no-underline d-flex flex-wrap align-items-center justify-content-end"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", null, _toDisplayString(_ctx.$tc('common.goToYourReservations', _ctx.count())), 1),
        _hoisted_3,
        (_ctx.hasRemainingTime())
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$tc('common.reservationValidFor', _ctx.remainingMinutes())), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}